import type { Kind, Tier, StakingEffect } from "@/api/types";
import { KIND_COLOR } from "@/lib/colors";
import { KIND_GLYPH, KIND_LABEL, TIER_LABEL } from "@/lib/tier";

export function KindBadge({
  kind,
  staking,
  tier,
  flagged = false,
  className = "",
}: {
  kind: Kind;
  staking?: StakingEffect;
  tier?: Tier;
  flagged?: boolean;
  className?: string;
}) {
  const color = KIND_COLOR[kind];
  const label = staking
    ? staking.kind === "reward"
      ? "REBASE"
      : "STAKING"
    : tier && tier !== "none"
      ? `${TIER_LABEL[tier].toUpperCase()} ${KIND_LABEL[kind]}`
      : KIND_LABEL[kind];
  return (
    <span
      className={`inline-flex h-4 items-center gap-1 rounded-sm border px-1 text-2xs font-semibold leading-none whitespace-nowrap ${className}`}
      style={{
        color,
        borderColor: color,
        background: flagged ? `color-mix(in srgb, ${color} 18%, transparent)` : "transparent",
      }}
      title={`${label}${flagged ? " (flagged)" : ""}`}
    >
      <span aria-hidden>{KIND_GLYPH[kind]}</span>
      {label}
    </span>
  );
}
